import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Grid,
  Box,
  Card,
  CardContent,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GraficoCategorias, GraficoUbicacion } from '../componentes/graficoCategorias';

export default function Dashboard() {
  const [usuario, setUsuario] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('usuario');

    // 🔴 Validación fuerte
    if (!storedUser || storedUser === "undefined") {
      console.warn("Usuario no encontrado");
      navigate('/login');
      return;
    }

    try {
      const parsedUser = JSON.parse(storedUser);
      setUsuario(parsedUser);
    } catch (error) {
      console.error("Error parseando usuario:", error);
      localStorage.removeItem('usuario');
      navigate('/login');
    }
  }, [navigate]);

  // ⏳ Loader bonito mientras carga
  if (!usuario) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <CircularProgress />
        <Typography mt={2}>Cargando datos del usuario...</Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 5 }}>
      
      {/* 🔵 Header */}
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold">
          👋 Bienvenido, {usuario.nombre}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Panel de reportes de productos
        </Typography>
      </Box>

      {/* 📊 Gráficos */}
      <Grid container spacing={3}>
        
        {/* Categorías */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              borderRadius: 4,
              boxShadow: 3,
              height: '100%'
            }}
          >
            <CardContent>
              <Typography variant="h6" mb={2}>
                📦 Productos por Categoría
              </Typography>
              <GraficoCategorias />
            </CardContent>
          </Card>
        </Grid>

        {/* Ubicación */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              borderRadius: 4,
              boxShadow: 3,
              height: '100%'
            }}
          >
            <CardContent>
              <Typography variant="h6" mb={2}>
                📍 Productos por Ubicación
              </Typography>
              <GraficoUbicacion />
            </CardContent>
          </Card>
        </Grid>

      </Grid>
    </Container>
  );
}